/**
 * The site-wide font stack, for use in JS/TS style objects (react-select `styles`, inline styles).
 *
 * Kept byte-identical to the `body` rule in `utils/styles/index.scss` — if you change one, change both.
 *
 * 🚩 **Never name a single family here.** Several react-select style objects used to hardcode
 * `fontFamily: 'Poppins'` with no fallback, and Poppins ships **no Hebrew glyphs** — so any Hebrew
 * value (a company name in the `/admin/users` company filter, for instance) fell through to the
 * browser's default serif and looked nothing like the rest of the page. **Rubik** is the Hebrew-capable
 * face in this stack, which is why the order matters: Latin resolves to Roboto, Hebrew falls through to
 * Rubik, and only then to the generic fallbacks.
 */
export const SITE_FONT_STACK = "Roboto, Rubik, Poppins, Arial, sans-serif";
